import { motion, isValidMotionProp, MotionProps } from "framer-motion"
import { BoxProps, chakra } from "@chakra-ui/react"
import React from "react"

const MotionBoxComponent = chakra(motion.div, {
  shouldForwardProp: prop => isValidMotionProp(prop) || prop === "children",
})

export type MotionBoxProps = MotionProps & Omit<BoxProps, "transition">

const MotionBox = React.forwardRef<HTMLDivElement, MotionBoxProps>((props, ref) => {
  const { transition, ...restProps } = props
  // Type assertion needed because chakra() merges BoxProps which has a conflicting transition type
  // The underlying motion.div accepts framer-motion's transition, but TypeScript sees Chakra's CSS transition type
  return <MotionBoxComponent ref={ref} transition={transition as any} {...(restProps as any)} />
})

MotionBox.displayName = "MotionBox"

export default MotionBox
